module.exports = __webpack_public_path__ + "static/11invgde-c045d0f7369d4f7fbe96679ca29e9f68.gif";